import React, { useEffect, useState } from 'react'

interface LoadingProps {
  message?: string
}

export default function Loading({ message = 'Carregando...' }: LoadingProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-primary-200 border-t-primary-500 rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-text-muted">{message}</p>
      </div>
    </div>
  )
}

// Loading para a área de conteúdo (dentro do layout). Só aparece após 300ms
// para não piscar em carregamentos rápidos.
export function ContentLoading() {
  const [visivel, setVisivel] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => setVisivel(true), 300)
    return () => clearTimeout(timer)
  }, [])

  return (
    <div className="h-full w-full flex items-center justify-center">
      {visivel && (
        <div className="w-8 h-8 border-[3px] border-primary-200 border-t-primary-500 rounded-full animate-spin" />
      )}
    </div>
  )
}